export const MasterData = [
  {
    title: 'Firm Entry',
    path: '/FirmEntry'
  },
  {
    title: 'Firm Register',
    path: '/FirmTable'
  },
  {
    title: 'Employee Entry',
    path: '/EmployeeEntry'
  },
  {
    title: 'Employee Register',
    path: '/EmployeeTable'
  },
  {
    title: 'Cloth Entry',
    path: '/ClothEntry'
  },
  {
    title: 'Cloth Register',
    path: '/ClothTable'
  },
  {
    title: 'Item Entry',
    path: '/ItemEntry'
  },
  {
    title: 'Item Register',
    path: '/ItemTable'
  },
  {
    title: 'Job Rate',
    path: '/JobRate'
  },
  {
    title: 'Department Master',
    path: '/DepartmentEntry'
  },
  {
    title: 'Panna Master',
    path: '/PannaEntry'
  },
  // {
  //   title: 'Item Average Master',
  //   path: '/ItemAverageMaster'
  // },
  {
    title: 'Item Average Register',
    path: '/ItemAvgRegister'
  },
  {
    title: 'Rack Master',
    path: '/RackEntry'
  },
  {
    title: 'Purchase Entry',
    path: '/PurchaseEntry'
  },
  {
    title: 'Purchase Register',
    path: '/PurchaseRegister'
  },
  {
    title: 'Price List Entry',
    path: '/PriceListEntry'
  }
];

export const Company = [
  {
    title: 'Firm Entry',
    path: '/FirmEntry'
  },
  {
    title: 'Firm Register',
    path: '/FirmTable'
  }
];

export const SalePurchaseParty = [
  {
    title: 'Sale & Purchase Party',
    path: '/SalePurchaseEntry'
  },
  {
    title: 'Sale & Purchase Party Register',
    path: '/SalePurchaseTable'
  }
]

export const Employee = [
  {
    title: 'Employee Entry',
    path: '/EmployeeEntry'
  },
  {
    title: 'Employee Register',
    path: '/EmployeeTable'
  }
];

export const Cloth = [
  {
    title: 'Cloth Entry',
    path: '/ClothEntry'
  },
  {
    title: 'Cloth Register',
    path: '/ClothTable'
  }
];

export const Items = [
  {
    title: 'Item Entry',
    path: '/ItemEntry'
  },
  {
    title: 'Item Register',
    path: '/ItemTable'
  },
  {
    title: 'Item Job Rate',
    path: '/JobRateEntry'
  },
  {
    title: 'Job Rate Register',
    path: '/JobRateTable'
  },
  {
    title: 'Item Average',
    path: '/ItemAverageMaster'
  },
  {
    title: 'Item Material',
    path: '/item-material'
  },
  {
    title: 'Item Material Reg',
    path: '/item-material-reg'
  }
];



export const Department = [
  {
    title: 'Department Master',
    path: '/DepartmentEntry'
  }
];

export const Panna = [
  {
    title: 'Panna Master',
    path: '/PannaEntry'
  }
];

export const workerMaster = [
  {
    title: 'Category Master',
    path: '/CategoryMaster'
  }
];

// export const ItemAverageMaster = [
//   {
//     title: 'Item Average Master',
//     path: '/ItemAverageMaster'
//   }
// ];

export const Rack = [
  {
    title: 'Rack Master',
    path: '/RackEntry'
  }
];

export const BrandMenu = [
  {
    title: 'Brand Entry',
    path: '/brand-entry'
  }
];

export const locationMenu = [
  {
    title: 'Location Entry',
    path: '/location-entry'
  }
];

export const Purchase = [
  {
    title: 'Purchase Entry',
    path: '/PurchaseEntry'
  },
  {
    title: 'Purchase Register',
    path: '/PurchaseRegister'
  }
];

export const PriceList = [
  {
    title: 'Price List Entry',
    path: '/PriceListEntry'
  }
];

export const SchoolMaster = [
  {
    title: 'School Master',
    path: '/SchoolEntry'
  }
];


export const TransportMaster = [
  {
    title: 'Transport Master',
    path: '/TransportEntry'
  }
];

export const LogoMaster = [
  {
    title: 'Logo Master',
    path: '/LogoEntry'
  }
];

export const MaterialMaster = [
  {
    title: 'Material Master',
    path: '/MaterialEntry'
  },
  {
    title: 'Material Inward Entry',
    path: '/MaterialInwardEntry'
  },
  {
    title: 'Material Inward Register',
    path: '/MaterialInwardTable'
  },
  {
    title: 'Material Outward Entry',
    path: '/MaterialOutwardEntry'
  },
  {
    title: 'Material Outward Register',
    path: '/MaterialOutwardTable'
  },
];

export const ClothStockMaster = [
  {
    title: 'Cloth Stock Entry',
    path: '/ClothStkEntry'
  },
  {
    title: 'Cloth Stock Register',
    path: '/ClothStkTable'
  },
];

export const clothStockReg = [
  {
    title: 'Cloth Stock Entry',
    path: '/manual-cloth-stock'
  },
  {
    title: 'Cloth Stock Register',
    path: '/manual-cloth-stock-reg'
  },
  {
    title: 'Common Cloth Stock Register',
    path: '/main-cloth-stock-reg'
  },
  {
    title: 'Transfer Cloth',
    path: '/transfer-cloth-entry'
  },
  {
    title: 'Transfer Cloth Reg',
    path: '/transfer-cloth-reg'
  }
];

export const ReadyMadestk = [
  {
    title: 'Ready Made Stock',
    path: '/ReadyMStkEntry'
  },
  {
    title: 'Ready Made Stock Register',
    path: '/ReadyMStkTable'
  },
];

export const Pricepercentgrp = [
  {
    title: 'Price Percent Group',
    path: '/PricePercentGEntry'
  }
];

export const QuotationMaster = [
  {
    title: 'Quotation Entry',
    path: '/quotationentry'
  },
  {
    title: 'Quotation Register',
    path: '/QuotationTable'
  },
  {
    title: 'Multiple Quotation',
    path: '/multi-quotation'
  },
  {
    title: 'Multiple Quotation Reg',
    path: '/multi-quotation-reg'
  }
];

export const SaleOrderList = [
  {
    title: 'Quotation No Wise',
    path: '/SOQTwise'
  },
  {
    title: 'Direct Sale Order',
    path: '/DirectSO'
  },
  {
    title: 'Sale Order Register',
    path: '/SaleOrderTable'
  },
  {
    title: 'Cloth Issue Register',
    path: '/ClothIssueReg2'
  },
];

export const SORateList = [
  {
    title: 'Quotation Wise',
    path: '/SaleOrderRate'
  },
  {
    title: 'Manually Wise',
    path: '/SORateManually'
  }
];

export const PurchaseOrdMaster = [
  {
    title: 'Purchase Order Entry',
    path: '/PurchaseOrderEntry'
  },
  {
    title: 'Purchase Order Register',
    path: '/PurchaseOrderTable'
  },
  {
    title: 'Purchase Order Extra',
    path: '/POExtraEntry'
  }
];

export const InwardMaster = [
  {
    title: 'Purchase Inward Entry',
    path: '/PurchaseInwardEntry'
  },
  {
    title: 'Direct Purchase Inward Entry',
    path: '/DirectPurchaseInwardEntry'
  },
  {
    title: 'Purchase Inward Register',
    path: '/PurchaseInwardTable'
  }
];


export const ClothIssueTitle = [
  {
    title: 'Cloth Issue Entry',
    path: '/ClothIssueEntry'
  },
  {
    title: 'Cloth Issue Register',
    path: '/ClothIssueReg'
  },

];

export const CuttingList = [
  // {
  //   title: 'Cutting Entryold',
  //   path: '/CuttingEntry'
  // },
  {
    title: 'Cutting Entry',
    path: '/cutting-entry'
  },
  {
    title: 'Cutting Register',
    path: '/CuttingRegister'
  },
  {
    title: 'Cutting Return',
    path: '/CuttingReturnRegister'
  },
  {
    title: 'Contractor (Cut-To-Pack)',
    // path: '/ContractorEntry'
    path: '/cutting-contractor-entry'
  },
  {
    title: 'Contractor Register',
    path: '/ContractorRegister'
  },
  {
    title: 'Contractor Return',
    path: '/ContractorReturnRegister'
  },

];

export const NumberingList = [

  {
    title: 'Numbering Entry',
    path: '/numbering-entry'
  },
  {
    title: 'Numbering Register',
    path: '/numberingRegister'
  },

  {
    title: 'Numbering Inward Register',
    path: '/numberinginwardRegister'
  },
];

export const FusioningList = [
  {
    title: 'Fusioning Entry',
    path: '/fusioning-entry'
  },
  {
    title: 'Fusioning Register',
    path: '/fusioning-reg'
  },
  {
    title: 'Fusioning Inward Register',
    path: '/fusion-inward-reg'
  },
];

export const ReturnList = [
  {
    title: 'Cutting Return',
    path: '/CuttingReturnRegister'
  },
  {
    title: 'Contractor Return',
    path: '/ContractorReturnRegister'
  },


];

export const StitchEntrylist = [
  {
    title: 'Stitching Entry',
    path: '/StitchInhouseEntry'
  },
  {
    title: 'Stitching Register',
    path: '/StitchingRegister'
  },
  {
    title: 'Stitching Return Reg.',
    path: '/StitchingReturnRegister'
  },
  {
    title: 'Contractor Entry(Stitch-To-Pack)',
    path: '/StitchContractorEntry'
  },
  {
    title: 'Contractor Register',
    path: '/StitchContractorReg'
  },
  ,
  {
    title: 'Contractor Returns Register',
    path: '/StitchingContractorReturnRegister'
  }
];

export const KajeMenu = [
  {
    title: 'Kaje Entry',
    path: '/KajeEntry'
  },
  {
    title: 'Kaje Register',
    path: '/KajeRegister'
  },
];

export const PressMenu = [
  {
    title: 'Press Entry',
    path: '/PressEntry'
  },

];

export const KjPrIssInwMenu = [
  {
    title: 'Kaje-Press(Iron) Issue/Inward Entry',
    path: '/Kaje-PressIssueInward'
  },
  {
    title: 'Kaje Register',
    path: '/KajeRegister-Production'
  },
  {
    title: 'Press Register',
    path: '/PressRegister-Production'
  },
];

export const StockMenu = [
  // {
  //   title: 'Stock Entry',
  //   path: '/StockEntry-Production'
  // },
  {
    title: 'Stock Production Entry',
    path: '/StkProductionEntry'
  },
  {
    title: 'Stock Production Register',
    path: '/StkProductionRegister'
  },
  {
    title: 'Manual Stock Entry',
    path: '/Manual-stock'
  },
  {
    title: 'Manual Stock Register',
    path: '/Manual-StockReg'
  }

];

export const PackingMenu = [
  {
    title: 'Packing Entry',
    path: '/packing-entry'
  },
  {
    title: 'Packing Register',
    path: '/packing-register'
  },
  {
    title: 'Shifting Register',
    path: '/shifting-register'
  },
  {
    title: 'Sale Invoice Generation',
    path: '/packing-slip-register'
  },
  {
    title: 'Sale Invoice Register',
    path: '/sale-invoice-register'
  }

];

export const InvoiceMenu = [
  {
    title: 'Invoice Entry',
    path: '/invoice-entry'
  },
  {
    title: 'Invoice Register',
    path: '/invoice-register'
  }

];

export const jobworkMenu = [
  {
    title: 'Jobwork Payment Entry',
    path: '/jobwork-entry'
  },
  {
    title: 'Jobwork Payment Register',
    path: '/jobwork-payment-register'
  },
  {
    title: 'Payment Register',
    path: '/payment-register'
  },
  {
    title: 'Advance Amount',
    path: '/advance-payment'
  }

];

export const ReceiptMenu = [
  {
    title: 'Sale Receipt Entry',
    path: '/Sale-Receipt-Entry'
  },
  // {
  //   title: 'Invoice Register',
  //   path: ''
  // }

];

export const ReportMenu = [
  {
    title: 'Sale Ledger Statement',
    path: '/Sale-Ledger-Statement'
  },
];

export const Adv_RT_Settlment_Menu = [
  {
    title: 'Adv/RT.Settlment Entry',
    path: '/Adv-RT-Settlment-Entry'
  },
  {
    title: 'Adv/RT.Settlment Entry',
    path: '/Adv-RT-Settlment-Entry'
  },
  {
    title: 'Adv/RT.Settlment Entry',
    path: '/Adv-RT-Settlment-Entry'
  },
];